import { Divider } from "antd";
import React from "react";

interface QaDividerProps {
    title: string;
}

export const QaDivider = ({ title }: QaDividerProps) => (
    <div>
        <span>
            <strong>{title}</strong>
        </span>
        <Divider style={{ marginTop: 8, marginBottom: 8 }} />
    </div>
);
